import {Component, OnInit} from '@angular/core';
import {environment} from '../../../../../environments/environment';
import {globalConst} from '../../../../../environments/global-const';

@Component({
  selector: 'app-environment-button',
  templateUrl: './environment-button.component.html',
  styleUrls: ['./environment-button.component.scss']
})
export class EnvironmentButtonComponent implements OnInit {

  isProduction = environment.production;
  isStaging = environment.staging;
  isDevelopment = environment.development;

  constructor() {
  }

  ngOnInit(): void {
  }

  changeEnvironment() {
    const {devURL, prodURL, stagingURL} = globalConst;
    const currentURL = window.location.href;

    if (this.isDevelopment) {
      window.location.href = currentURL.replace(devURL, prodURL);
    } else if (this.isStaging) {
      window.location.href = currentURL.replace(stagingURL, prodURL);
    } else {
      window.location.href = currentURL.replace(prodURL, stagingURL);
    }
  }

  get currentClass(): string {
    if (this.isStaging || this.isDevelopment) {
      return 'staging-environment';
    }

    return 'production-environment';
  }

  get otherEnvironment(): string {
    if (this.isStaging || this.isDevelopment) {
      return 'Production';
    }

    return 'Staging';
  }

  get currentEnvironment(): string {
    if (this.isStaging) {
      return 'Staging';
    } else if (this.isDevelopment) {
      return 'Development';
    }

    return 'Production';
  }

  get tooltipText(): string {
    return `You are currently in ${this.currentEnvironment}`;
  }
}
